export default __webpack_public_path__ + "static/media/bar_graph.23c65035.svg";